import {bytes} from '@netx/core/lib/underscore-netx';

export const getAssetFileSizeLabel = bytes; // (fileSize: number) => bytes(fileSize);

export default getAssetFileSizeLabel;
